import { isDefined, mapAsKeys } from '@sama/js-core';
import { every, map, matches, pickBy, random } from '@sama/micro-dash';
import { CheckboxAnswer } from '../../team-apis/otterdam/answers/checkbox-answer';
import { CheckboxOutput } from '../../team-apis/otterdam/outputs/checkbox-output';
import { OutputHelper } from './output-helper';

export class CheckboxOutputHelper extends OutputHelper<
  CheckboxOutput,
  CheckboxAnswer
> {
  override isAnswerBlank(answer: CheckboxAnswer | undefined) {
    return every(answer, (value) => value === '0');
  }

  override getLabelFor(
    answer: CheckboxAnswer | undefined,
    output: CheckboxOutput,
  ) {
    const selectedLabels = this.getSelectedValue(answer).map(
      (val) =>
        output.answer_options.find(matches({ name: val }))?.label ||
        `invalid option: ${val}`,
    );
    return selectedLabels.join('; ');
  }

  override makeRandomAnswer(output: CheckboxOutput) {
    return mapAsKeys(
      output.answer_options.map((option) => option.name),
      () => random(1).toString() as '0' | '1',
    );
  }

  override getBlankAnswer(output: CheckboxOutput) {
    return mapAsKeys(
      output.answer_options.map((option) => option.name),
      () => '0',
    );
  }

  override getMatchingAnswerOptionIds(
    answer: CheckboxAnswer | undefined,
    output: CheckboxOutput,
  ) {
    return this.getSelectedValue(answer)
      .map((val) => output.answer_options.find(matches({ name: val }))?.id)
      .filter(isDefined);
  }

  private getSelectedValue(answer: CheckboxAnswer | undefined) {
    return map(
      pickBy(answer, (val) => val === '1'),
      (_val, key) => key,
    );
  }
}
